import React from 'react';
import PropTypes from 'prop-types';

import ContentSection from './ContentSection';
import {RICHTEXT_PROP_TYPES, SLICE_PROP_TYPES} from 'cms/proptypes';

const PrismicContentSection = ({slice, isMidFunnel}) => {
    const contentSliceTitle = slice.primary.content_slice_title;
    const contentSliceRichText = slice.primary.content_slice_rich_text;
    const sliceTheme = slice.primary.content_slice_theme;
    const sectionId = slice.primary.section_id;

    return (
        <ContentSection
            sectionId={sectionId}
            contentSliceTitle={contentSliceTitle}
            contentSliceRichText={contentSliceRichText}
            sliceTheme={sliceTheme}
            isMidFunnel={isMidFunnel}
        />
    );
};

/* eslint-disable camelcase */
PrismicContentSection.propTypes = {
    slice: PropTypes.shape({
        ...SLICE_PROP_TYPES,
        primary: PropTypes.shape({
            content_slice_theme: PropTypes.string,
            content_slice_title: RICHTEXT_PROP_TYPES.isRequired,
            content_slice_rich_text: RICHTEXT_PROP_TYPES.isRequired,
            section_id: PropTypes.string,
        }).isRequired,
        items: PropTypes.array.isRequired,
    }).isRequired,
    isMidFunnel: PropTypes.bool,
};

export default PrismicContentSection;
